import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选片单与编辑推荐，发现你的下一部必追好剧
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={`${item.title} - ${item.subtitle}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-3 flex-1">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}